import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="section__inner">
        <motion.p
          className="section__eyebrow"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
        >
          Summary
        </motion.p>

        <div className="about__grid">
          <motion.h2
            className="about__heading"
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
          >
            Modern engineering with measurable impact.
          </motion.h2>

          <div className="about__copy">
            <motion.p
              variants={fadeUp}
              custom={2}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
            >
              Results-driven Software Engineer with a strong foundation in modern
              development practices — including object-oriented programming, web
              services, databases, microservices, and cloud-native technologies.
            </motion.p>
            <motion.p
              variants={fadeUp}
              custom={3}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
            >
              Skilled in designing, building, and deploying scalable applications,
              with experience in collaborative, agile development. Based in Israel — open to new opportunities and collaborations.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
